import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';
import {
    GeoRecordCategory,
    GeoRecordCategorySummary,
} from '@/vue3/api/models/geoRecordCategoryModels';

export const useGeoRecordCategoryCustomLayerService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // methods
    const getGeoRecordCategoryCustomLayersSummary = async (): Promise<
        GeoRecordCategorySummary[]
    > => {
        const res = await axios.get(`${apiUrl}/geo-record-cat-custom-layer/summary`);
        return res.data;
    };

    const getAllGeoRecordCategoryCustomLayerByOrg = async (org_id): Promise<GeoRecordCategory[]> => {
        const res = await axios.get(`${apiUrl}/geo-record-cat-custom-layer/org/${org_id}`);
        return res.data ? res.data : [];
    };

    const getGeoRecordCategoryCustomLayer = async (
        id: number,
    ): Promise<GeoRecordCategory> => {
        const res = await axios.get(`${apiUrl}/geo-record-cat-custom-layer/${id}`);
        return res.data;
    };

    const getAllGeoRecordCategoryCustomLayerAsTreeByOrg = async (
        organization_id: number
    ): Promise<any[]> => {
        const res = await axios.get(`${apiUrl}/geo-record-cat-custom-layer/tree/${organization_id}`);
        return res.data;
    };

    const createGeoRecordCategoryCustomLayer = async (
        category: GeoRecordCategory,
    ): Promise<GeoRecordCategory[]> => {
        const res = await axios.post(`${apiUrl}/geo-record-cat-custom-layer`, category);
        return res.data;
    };

    const updateGeoRecordCategoryCustomLayer = async (
        category: GeoRecordCategory,
    ): Promise<GeoRecordCategory[]> => {
        const res = await axios.put(`${apiUrl}/geo-record-cat-custom-layer`, category);
        return res.data;
    };

    const deleteGeoRecordCategoryCustomLayer = async (id: number) => {
        return await axios.deleteId(`${apiUrl}/geo-record-cat-custom-layer/${id}`);
    };

    return {
        getAllGeoRecordCategoryCustomLayerAsTreeByOrg,
        getGeoRecordCategoryCustomLayersSummary,
        getGeoRecordCategoryCustomLayer,
        deleteGeoRecordCategoryCustomLayer,
        updateGeoRecordCategoryCustomLayer,
        getAllGeoRecordCategoryCustomLayerByOrg,
        createGeoRecordCategoryCustomLayer,
    };
};
